import { ReceivingList, SortKeyObject, SearchById, GetReceivingParamsDetaildById, PoSummary, LocationPayload, MerchandiseArrivalEntity } from '../../models';

export interface ReceivingState {
    GetReceiving: any;
    GetReceivingSuccess: any;
    GetReceivingViewModel: ReceivingList[];
    GetReceivingDetailById: GetReceivingParamsDetaildById;
    GetReceivingDetailByIdSucess: any;
    GetReceivingSearch: any;
    GetReceivingSorting: SortKeyObject;
    GetPoSearchbyId: any;
    GetPoSearchSuccess: any;
    GetLookupDetail: string;
    GetLookUpDetailSuccess: any;
    GetLookUpGridSuccess: any;
    GetItemList: any;
    GetItemListSuccess: any;
    GetSupplierItemNumberSuccess: any;
    GetPoSummary: PoSummary;
    GetPoSummarySuccess: any;
    GetSupplierList: any;
    GetSupplierSuccess: any;
    GetSearchSupplier: any;
    GetLocation: LocationPayload;
    GetLocationSuccess: any;
    PostReceiving: MerchandiseArrivalEntity;
    PostReceivingSuccess: any;
    SaveReceiving: MerchandiseArrivalEntity;
    SaveReceivingSucess: any;
    ReceivingformDetails: any;

 }
    export const intialReceivingState: ReceivingState = {
    GetReceiving: null,
    GetReceivingSuccess: null,
    GetReceivingDetailById: null,
    GetReceivingSearch: null,
    GetReceivingViewModel: null,
    GetReceivingSorting: null,
    GetPoSearchbyId: null,
    GetPoSearchSuccess: null,
    GetLookupDetail: null,
    GetLookUpDetailSuccess: null,
    GetLookUpGridSuccess: null,
    GetItemList: null,
    GetItemListSuccess: null,
    GetSupplierItemNumberSuccess: null,
    GetReceivingDetailByIdSucess: null,
    GetPoSummary: null,
    GetPoSummarySuccess: null,
    GetSupplierList: null,
    GetSupplierSuccess: null,
    GetSearchSupplier: null,
    GetLocation: null,
    GetLocationSuccess: null,
    PostReceiving: null,
    PostReceivingSuccess: null,
    SaveReceiving: null,
    SaveReceivingSucess: null,
    ReceivingformDetails: null,
 };
